var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgPattern2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 468,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234 78c43.078 0 78 34.922 78 78v156h-56c-55.228 0-100-44.772-100-100v-56c0-43.078 34.922-78 78-78Z",
    fill: "#66E2DC"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FCFAF9",
    x: 78,
    y: 78,
    width: 78,
    height: 78,
    rx: 39
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#66E2DC",
    width: 78,
    height: 156,
    rx: 39
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFB964",
    y: 156,
    width: 156,
    height: 156,
    rx: 78
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 312)",
    stroke: "#FCFAF9",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 154,
    height: 154,
    rx: 77
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 79,
    width: 76,
    height: 76,
    rx: 38
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPattern2);
export default __webpack_public_path__ + "static/media/bg-pattern-2.da4438d95f7dcf5bc9f0ec4acd52cc2f.svg";
export { ForwardRef as ReactComponent };